import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-search';
export var ID = 'icon-search';
/* eslint-disable max-len */

export var SVGSearch = function SVGSearch() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 16 16"
  }, React.createElement("path", {
    d: "M12.1237341,10.1237341 L15,13 L13,15 L10.1237341,12.1237341 C9.21383771,12.6796483 8.14432993,13 7,13 C3.6862915,13 1,10.3137085 1,7 C1,3.6862915 3.6862915,1 7,1 C10.3137085,1 13,3.6862915 13,7 C13,8.14432993 12.6796483,9.21383771 12.1237341,10.1237341 Z M7,11 C9.209139,11 11,9.209139 11,7 C11,4.790861 9.209139,3 7,3 C4.790861,3 3,4.790861 3,7 C3,9.209139 4.790861,11 7,11 Z"
  }));
};
/* eslint-disable max-len */

var Search = function Search(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGSearch
  });
};

Search.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default Search;